
import "./App.css";
import Home from "./home/home"

function App() {

  return (
    <div className="App">
      <header className="App-header">
        <img src="./img/img-logo-goop-azul.png" className="App-logo" alt="logo" />
      </header>
      <Home></Home>
    </div>
  );
}

export default App;
